import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["percent", "strokeColor", "size"];
import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';

// Constants
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { PROGRESS_BAR_SIZE } from './progressBar.constants';
var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent,
    strokeColor = _ref.strokeColor,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Progress, _extends({}, rest, {
    strokeColor: strokeColor,
    percent: percent,
    size: size,
    showInfo: false
  }));
};
ProgressBar.propTypes = {
  percent: PropTypes.number,
  strokeColor: PropTypes.string,
  size: PropTypes.string
};
ProgressBar.defaultProps = {
  percent: 0,
  strokeColor: EMPTY_STRING,
  size: PROGRESS_BAR_SIZE.SMALL
};
export default ProgressBar;